import React from 'react';
import './loading.css';

const LoadingOverlay = () => {
    return (
        <div className="loading-overlay">
            <div className="loading-circle"></div>
        </div>
    );
};

export default LoadingOverlay;